module.exports = __webpack_public_path__ + "static/media/sneaky_peaky_1.11360f03.mp3";